/**
 * @file
 * React component that generates the Angler Type
 * @returns a span of angler class type of 'Pro-Anglers' or 'Con-Anglers'
 */
import * as React from 'react';

/**
 *
 * @param {string} value
 * @returns <li> with Angler Name
 */
interface IAnglerProps {
  // String representing the NAME_FONTNAME param of an Angler.
  value: string;
}
const Angler: React.FunctionComponent<IAnglerProps> = ({ value }) => (
  <li className="angler-list__item">{value}</li>
);

/**
 *
 * @param {string[]} list
 * @returns <ol> of Angler <li>s
 */
interface IAnglerListProps {
  // Array of Angler NAME_FONTNAME params;
  list: string[];
}
const AnglerList: React.FunctionComponent<IAnglerListProps> = ({ list }) => {
  const newList = list.map(item => {
    return <Angler value={item} key={item} />;
  });

  return (
    <ol className="angler-list" data-testid="angler-list">
      {newList}
    </ol>
  );
};

export default AnglerList;
